module.exports = __webpack_public_path__ + "static/media/PP_2019 PPbag_pdf.b38585c6.pdf";